export default "__VITE_ASSET__XGBUEiRG__"